"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./TheMemes.module.scss";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import dynamic from "next/dynamic";
import { useContext, useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AuthContext } from "@/components/auth/Auth";
import MemePageMintCountdown from "@/components/mint-countdown-box/MemePageMintCountdown";
import NFTImage from "@/components/nft-image/NFTImage";
import { publicEnv } from "@/config/env";
import { useTitle } from "@/contexts/TitleContext";
import type { MemesExtendedData, NFT, NftRank, NftTDH } from "@/entities/INFT";
import type { ConsolidatedTDH } from "@/entities/ITDH";
import type { Transaction } from "@/entities/ITransaction";
import { areEqualAddresses } from "@/helpers/Helpers";
import { fetchUrl } from "@/services/6529api";
import { commonApiFetch } from "@/services/api/common-api";
import Link from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import NftNavigation from "../nft-navigation/NftNavigation";
import { MemePageCollectorsRightMenu, MemePageCollectorsSubMenu } from "./MemePageCollectors";
import { MemePageLiveRightMenu, MemePageLiveSubMenu } from "./MemePageLive";
import { MemePageYourCardsRightMenu, MemePageYourCardsSubMenu } from "./MemePageYourCards";
import { getMemeTabTitle, MEME_FOCUS, MEME_TABS, TabButton } from "./MemeShared";
import UpcomingMemePage from "./UpcomingMemePage";
const MemePageArt = dynamic(() => import("./MemePageArt").then(mod => mod.MemePageArt));
const MemePageActivity = dynamic(() => import("./MemePageActivity").then(mod => mod.MemePageActivity));
const MemePageTimeline = dynamic(() => import("./MemePageTimeline").then(mod => mod.MemePageTimeline));
const ACTIVITY_PAGE_SIZE = 25;
export default function MemePage(t0) {
  const $ = _c(95);
  const {
    nftId
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const {
    setTitle
  } = useTitle();
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [connectedWallets, setConnectedWallets] = useState(t1);
  let t2;
  if ($[1] !== searchParams) {
    t2 = searchParams?.get("focus");
    $[1] = searchParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const focusParam = t2;
  let t3;
  bb0: {
    if (!focusParam) {
      t3 = undefined;
      break bb0;
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = Object.values(MEME_FOCUS);
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== focusParam) {
      t5 = (t4 as MEME_FOCUS[]).find(sd => sd === focusParam);
      $[4] = focusParam;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t3 = t5;
  }
  const resolvedRouterFocus = t3;
  const [activeTab, setActiveTab] = useState(resolvedRouterFocus ?? MEME_FOCUS.LIVE);
  let t4;
  if ($[6] !== resolvedRouterFocus) {
    t4 = () => ({
      [MEME_FOCUS.LIVE]: true,
      [MEME_FOCUS.YOUR_CARDS]: true,
      [MEME_FOCUS.COLLECTORS]: true,
      [MEME_FOCUS.THE_ART]: resolvedRouterFocus === MEME_FOCUS.THE_ART,
      [MEME_FOCUS.ACTIVITY]: resolvedRouterFocus === MEME_FOCUS.ACTIVITY,
      [MEME_FOCUS.TIMELINE]: resolvedRouterFocus === MEME_FOCUS.TIMELINE
    });
    $[6] = resolvedRouterFocus;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const [loadedTabs, setLoadedTabs] = useState(t4);
  let t5;
  if ($[8] !== connectedProfile?.wallets) {
    t5 = () => {
      setConnectedWallets(connectedProfile?.wallets?.map(_temp) ?? []);
    };
    $[8] = connectedProfile?.wallets;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== connectedProfile) {
    t6 = [connectedProfile];
    $[10] = connectedProfile;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[12] !== resolvedRouterFocus) {
    t7 = () => {
      const nextFocus = resolvedRouterFocus ?? MEME_FOCUS.LIVE;
      setActiveTab(prev => prev === nextFocus ? prev : nextFocus);
    };
    t8 = [resolvedRouterFocus];
    $[12] = resolvedRouterFocus;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[15] !== activeTab) {
    t9 = () => {
      setLoadedTabs(prev_0 => {
        if (prev_0[activeTab]) {
          return prev_0;
        }
        return {
          ...prev_0,
          [activeTab]: true
        };
      });
    };
    t10 = [activeTab];
    $[15] = activeTab;
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  useEffect(t9, t10);
  let t11;
  if ($[18] !== searchParams) {
    t11 = searchParams?.toString() ?? "";
    $[18] = searchParams;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const searchParamsString = t11;
  const [nft, setNft] = useState();
  const [nftNotFound, setNftNotFound] = useState(false);
  const [nftMeta, setNftMeta] = useState();
  const [nftBalance, setNftBalance] = useState(0);
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [];
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const [transactions, setTransactions] = useState(t12);
  const [myOwner, setMyOwner] = useState();
  const [myTDH, setMyTDH] = useState();
  const [myRank, setMyRank] = useState();
  const [userLoaded, setUserLoaded] = useState(false);
  let t13;
  let t14;
  if ($[21] !== activeTab || $[22] !== nft || $[23] !== nftId || $[24] !== setTitle) {
    t13 = () => {
      setTitle(getMemeTabTitle("The Memes", nftId, nft, activeTab));
    };
    t14 = [nft, nftId, activeTab, setTitle];
    $[21] = activeTab;
    $[22] = nft;
    $[23] = nftId;
    $[24] = setTitle;
    $[25] = t13;
    $[26] = t14;
  } else {
    t13 = $[25];
    t14 = $[26];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[27] !== activeTab || $[28] !== focusParam || $[29] !== nftNotFound || $[30] !== pathname || $[31] !== router || $[32] !== searchParamsString) {
    t15 = () => {
      if (!nftNotFound && focusParam === activeTab) {
        return;
      }
      const params = new URLSearchParams(searchParamsString);
      if (nftNotFound) {
        params.delete("focus");
      } else {
        params.set("focus", activeTab);
      }
      const queryString = params.toString();
      router.replace(queryString ? `${pathname}?${queryString}` : pathname, {
        scroll: false
      });
    };
    t16 = [activeTab, focusParam, pathname, router, searchParamsString, nftNotFound];
    $[27] = activeTab;
    $[28] = focusParam;
    $[29] = nftNotFound;
    $[30] = pathname;
    $[31] = router;
    $[32] = searchParamsString;
    $[33] = t15;
    $[34] = t16;
  } else {
    t15 = $[33];
    t16 = $[34];
  }
  useEffect(t15, t16);
  let t17;
  let t18;
  if ($[35] !== nftId) {
    t17 = () => {
      if (!nftId) {
        return;
      }
      let cancelled = false;
      const metaPromise = fetchUrl(`${publicEnv.API_ENDPOINT}/api/memes_extended_data?id=${nftId}`);
      const nftPromise = fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts?id=${nftId}&contract=${MEMES_CONTRACT}`);
      Promise.all([metaPromise, nftPromise]).then(t19 => {
        const [metaResponse, nftResponse] = t19;
        if (cancelled) {
          return;
        }
        const nftMetas = metaResponse.data;
        if (Array.isArray(nftMetas) && nftMetas.length === 1) {
          setNftMeta(nftMetas[0]);
          const mynft = nftResponse.data?.[0];
          setNft(mynft);
          setNftNotFound(false);
        } else {
          setNftMeta(undefined);
          setNft(undefined);
          setNftNotFound(true);
        }
      }).catch(() => {
        if (!cancelled) {
          setNftMeta(undefined);
          setNft(undefined);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t18 = [nftId];
    $[35] = nftId;
    $[36] = t17;
    $[37] = t18;
  } else {
    t17 = $[36];
    t18 = $[37];
  }
  useEffect(t17, t18);
  let t19;
  if ($[38] !== connectedWallets) {
    t19 = function updateNftBalances(data) {
      let countIn = 0;
      let countOut = 0;
      data.map(d => {
        if (connectedWallets.some(w_0 => areEqualAddresses(w_0, d.from_address))) {
          countOut = countOut + d.token_count;
          countOut;
        }
        if (connectedWallets.some(w_1 => areEqualAddresses(w_1, d.to_address))) {
          countIn = countIn + d.token_count;
          countIn;
        }
      });
      setNftBalance(countIn - countOut);
    };
    $[38] = connectedWallets;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  const updateNftBalances = t19;
  let t20;
  if ($[40] !== connectedWallets || $[41] !== nftId || $[42] !== updateNftBalances) {
    t20 = () => {
      if (connectedWallets.length && nftId) {
        fetchUrl(`${publicEnv.API_ENDPOINT}/api/transactions?contract=${MEMES_CONTRACT}&wallet=${connectedWallets.join(",")}&id=${nftId}`).then(response => {
          setTransactions(response.data);
          updateNftBalances(response.data);
          setUserLoaded(true);
        });
      } else {
        setNftBalance(0);
        setUserLoaded(true);
        setTransactions([]);
      }
    };
    $[40] = connectedWallets;
    $[41] = nftId;
    $[42] = updateNftBalances;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== connectedWallets || $[45] !== nftId) {
    t21 = [nftId, connectedWallets];
    $[44] = connectedWallets;
    $[45] = nftId;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  useEffect(t20, t21);
  let t22;
  if ($[47] !== connectedProfile || $[48] !== connectedWallets.length || $[49] !== nftId) {
    t22 = () => {
      if (connectedWallets.length > 0 && nftId && connectedProfile?.consolidation_key) {
        commonApiFetch({
          endpoint: `tdh/consolidation/${connectedProfile.consolidation_key}`
        }).then(response_0 => {
          setMyOwner(response_0);
          setMyTDH(response_0.memes.find(m => m.id === parseInt(nftId)));
          setMyRank(response_0.memes_ranks.find(m_0 => m_0.id === parseInt(nftId)));
        }).catch(() => {
          setMyOwner(undefined);
          setMyTDH(undefined);
          setMyRank(undefined);
        });
      }
    };
    $[47] = connectedProfile;
    $[48] = connectedWallets.length;
    $[49] = nftId;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const t23 = connectedProfile?.consolidation_key;
  let t24;
  if ($[51] !== connectedWallets || $[52] !== nftId || $[53] !== t23) {
    t24 = [nftId, connectedWallets, t23];
    $[51] = connectedWallets;
    $[52] = nftId;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  useEffect(t22, t24);
  let t25;
  if ($[55] !== activeTab || $[56] !== connectedWallets || $[57] !== loadedTabs || $[58] !== myOwner || $[59] !== myRank || $[60] !== myTDH || $[61] !== nft || $[62] !== nftBalance || $[63] !== nftMeta || $[64] !== transactions || $[65] !== userLoaded) {
    t25 = function printContent() {
      return <><Container className="p-0"><Row>{[MEME_FOCUS.LIVE, MEME_FOCUS.YOUR_CARDS, MEME_FOCUS.COLLECTORS].includes(activeTab) && nft && <><Col xs={{
                span: 12
              }} sm={{
                span: 12
              }} md={{
                span: 6
              }} lg={{
                span: 6
              }} className={`${styles.nftImageWrapper} pt-2 pb-5`}><NFTImage nft={nft} animation={true} height={650} showBalance={true} /></Col><MemePageLiveRightMenu show={activeTab === MEME_FOCUS.LIVE} nft={nft} nftMeta={nftMeta} nftBalance={nftBalance} />{userLoaded && <MemePageYourCardsRightMenu show={activeTab === MEME_FOCUS.YOUR_CARDS} transactions={transactions} wallets={connectedWallets} nft={nft} nftBalance={nftBalance} myOwner={myOwner} myTDH={myTDH} myRank={myRank} />}<MemePageCollectorsRightMenu show={activeTab === MEME_FOCUS.COLLECTORS} nft={nft} /></>}</Row><MemePageLiveSubMenu show={activeTab === MEME_FOCUS.LIVE} nft={nft} />{userLoaded && <MemePageYourCardsSubMenu show={activeTab === MEME_FOCUS.YOUR_CARDS} transactions={transactions} />}<MemePageCollectorsSubMenu show={activeTab === MEME_FOCUS.COLLECTORS} nft={nft} /></Container>{loadedTabs[MEME_FOCUS.THE_ART] && <MemePageArt show={activeTab === MEME_FOCUS.THE_ART} nft={nft} nftMeta={nftMeta} />}{loadedTabs[MEME_FOCUS.ACTIVITY] && <MemePageActivity show={activeTab === MEME_FOCUS.ACTIVITY} nft={nft} pageSize={ACTIVITY_PAGE_SIZE} />}{loadedTabs[MEME_FOCUS.TIMELINE] && <MemePageTimeline show={activeTab === MEME_FOCUS.TIMELINE} nft={nft} />}</>;
    };
    $[55] = activeTab;
    $[56] = connectedWallets;
    $[57] = loadedTabs;
    $[58] = myOwner;
    $[59] = myRank;
    $[60] = myTDH;
    $[61] = nft;
    $[62] = nftBalance;
    $[63] = nftMeta;
    $[64] = transactions;
    $[65] = userLoaded;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  const printContent = t25;
  const isLastCard = nftMeta?.collection_size === nft?.id;
  const t26 = isLastCard ? 6 : 12;
  let t27;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Row><Col><h1>The Memes</h1></Col></Row>;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== nft || $[69] !== nftMeta || $[70] !== searchParams) {
    t28 = nftMeta && nft && <><Row className="pt-3 pb-3"><Col className="d-flex"><NftNavigation nftId={nft.id} path="/the-memes" startIndex={1} endIndex={nftMeta.collection_size} params={searchParams} /></Col></Row><Row className="pt-2"><Col><h2 className="float-left"><Link href={`/the-memes?szn=${nftMeta.season}&sort=age&sort_dir=ASC`}>SZN{nftMeta.season}</Link></h2><h2 className="float-left"> | Card {nft.id} - </h2><h2 className="float-left">{nft.name}</h2></Col></Row></>;
    $[68] = nft;
    $[69] = nftMeta;
    $[70] = searchParams;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== t28) {
    t29 = <Container className="no-padding">{t27}{t28}</Container>;
    $[72] = t28;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== t26 || $[75] !== t29) {
    t30 = <Col sm={12} md={t26}>{t29}</Col>;
    $[74] = t26;
    $[75] = t29;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] !== isLastCard || $[78] !== nft) {
    t31 = isLastCard && <Col sm={12} md={6} className="d-flex align-items-center">{nft && <MemePageMintCountdown nft_id={nft.id} />}</Col>;
    $[77] = isLastCard;
    $[78] = nft;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== t30 || $[81] !== t31) {
    t32 = <Row>{t30}{t31}</Row>;
    $[80] = t30;
    $[81] = t31;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== activeTab || $[84] !== nft || $[85] !== nftMeta || $[86] !== printContent) {
    t33 = nftMeta && nft && <><Row className="pt-3 pb-3"><Col className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{MEME_TABS.map(tab => <TabButton key={`${nft.id}-${nft.contract}-${tab.focus}-tab`} tab={tab} activeTab={activeTab} setActiveTab={setActiveTab} />)}</Col></Row>{printContent()}</>;
    $[83] = activeTab;
    $[84] = nft;
    $[85] = nftMeta;
    $[86] = printContent;
    $[87] = t33;
  } else {
    t33 = $[87];
  }
  let t34;
  if ($[88] !== nftId || $[89] !== nftNotFound) {
    t34 = nftNotFound && <Row><Col><UpcomingMemePage id={nftId} /></Col></Row>;
    $[88] = nftId;
    $[89] = nftNotFound;
    $[90] = t34;
  } else {
    t34 = $[90];
  }
  let t35;
  if ($[91] !== t32 || $[92] !== t33 || $[93] !== t34) {
    t35 = <Container fluid={true} className={styles.mainContainer}><Row><Col><Container className="pt-4 pb-4">{t32}{t33}{t34}</Container></Col></Row></Container>;
    $[91] = t32;
    $[92] = t33;
    $[93] = t34;
    $[94] = t35;
  } else {
    t35 = $[94];
  }
  return t35;
}
function _temp(w) {
  return w.wallet;
}